<h1>{{ 'turbo.core.createScheduledReportDialog.title' | translate : 'Scheduled Report'}}</h1>
    <mat-dialog-content>
      <t4-container title="{{ 'turbo.core.createScheduledReportDialog.head' | translate : 'Timing' }}">
        <div style="text-align: center" *ngIf="false">
          <span class="helptext" style="text-align:center; font-size:0.9em; padding: 10px; max-width: 570px; display: inline-block;">
            {{ 'turbo.core.ReportScheduleDialog.msgReportDateInfo2' | translate : 'Report start and end date will be updated to reflect every consecutive run. A weekly report will, for example, push both dates one week forward for every run.' }}
          </span>
        </div>
        <div class="row">
          <div class="col-6" *ngIf="false">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'turbo.core.createScheduledReportDialog.lblReportDateFrom' | translate : 'Report start date'}}</mat-label>
              <mat-icon matPrefix>date_range</mat-icon>
              <input matInput [matDatepicker]="pickupPicker" required [(ngModel)]="fromDate">
              <mat-datepicker-toggle matSuffix [for]="pickupPicker"></mat-datepicker-toggle>
              <mat-datepicker #pickupPicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-6" *ngIf="false">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'turbo.core.createScheduledReportDialog.lblReportDateTo' | translate : 'Report end date'}}</mat-label>
              <mat-icon matPrefix>date_range</mat-icon>
              <input matInput placeholder="{{ 'turbo.core.createScheduledReportDialog.lblDateTo' | translate : 'To'}}" [matDatepicker]="pickupPicker2" [(ngModel)]="toDate">
              <mat-datepicker-toggle matSuffix [for]="pickupPicker2"></mat-datepicker-toggle>
              <mat-datepicker #pickupPicker2></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'turbo.core.createScheduledReportDialog.interval' | translate : 'Interval'}}</mat-label>
              <mat-select required [(ngModel)]="interval" matNativeControl>
                <mat-option value="3">
                  {{ 'turbo.core.createScheduledReportDialog.lblEveryDay' | translate : 'Every day'}}
                </mat-option>
                <mat-option value="2">
                  {{ 'turbo.core.createScheduledReportDialog.lblEveryWeek' | translate : 'Every week'}}
                </mat-option>
                <mat-option value="1">
                  {{ 'turbo.core.createScheduledReportDialog.lblEveryMonth' | translate : 'Every month'}}
                </mat-option>
                <mat-option value="0">
                  {{ 'turbo.core.createScheduledReportDialog.lblEveryYear' | translate : 'Every year'}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-6">
            <mat-form-field appearance="outline" *ngIf="interval=='2'">
              <mat-label>{{ 'turbo.core.createScheduledReportDialog.lblWeekday' | translate : 'Day of week'}}</mat-label>
              <mat-select required [(ngModel)]="dayOfWeek" matNativeControl>
                <mat-option value="1">
                  {{ 'turbo.core.Monday' | translate : 'Monday'}}
                </mat-option>
                <mat-option value="2">
                  {{ 'turbo.core.Tuesday'| translate : 'Tuesday'}}
                </mat-option>
                <mat-option value="3">
                  {{ 'turbo.core.Wednesday' | translate : 'Wednesday'}}
                </mat-option>
                <mat-option value="4">
                  {{ 'turbo.core.Thursday' | translate : 'Thursday'}}
                </mat-option>
                <mat-option value="5">
                  {{ 'turbo.core.Friday' | translate : 'Friday'}}
                </mat-option>
                <mat-option value="6">
                  {{ 'turbo.core.Saturday' | translate : 'Saturday'}}
                </mat-option>
                <mat-option value="0">
                  {{ 'turbo.core.Sunday' | translate : 'Sunday'}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </t4-container>
      <t4-container title="{{ 'turbo.core.createScheduledReportDialog.headDelivery' | translate : 'Delivery' }}">
        <div class="row">
          <div class="col-6">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'turbo.core.createScheduledReportDialog.drpFormat' | translate : 'Format'}}</mat-label>
              <mat-select required [(ngModel)]="format" matNativeControl>
                <mat-option value="1">
                  {{ 'turbo.core.createScheduledReportDialog.lblExcel' | translate : 'Excel'}}
                </mat-option>
                <mat-option value="0">
                  {{ 'turbo.core.createScheduledReportDialog.lblCsv' | translate : 'Csv'}}
                </mat-option>
                <mat-option value="2">
                  {{ 'turbo.core.createScheduledReportDialog.lblJson' | translate : 'Json'}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-6">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'turbo.core.createScheduledReportDialog.lblMethod' | translate : 'Method'}}</mat-label>
              <mat-select required [(ngModel)]="method" matNativeControl>
                <mat-option value="0">
                  {{ 'turbo.core.createScheduledReportDialog.lblEmail' | translate : 'Email'}}
                </mat-option>
                <mat-option value="1">
                  {{ 'turbo.core.createScheduledReportDialog.lblWebHook' | translate : 'WebHook'}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          </div>
          <div class="row">
            <div class="col-12">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'turbo.core.createScheduledReportDialog.lblEmailAddress' | translate : 'Email address'}}</mat-label>
                <mat-icon matPrefix>email</mat-icon>
                <input #txtEmail matInput type="email" required [(ngModel)]="email">
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-12" *ngIf="method == '1'">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'turbo.core.createScheduledReportDialog.lblWebHookUri' | translate : 'WebHook uri'}}</mat-label>
                <mat-icon matPrefix>homepage</mat-icon>
                <input #txtWebHook matInput required [(ngModel)]="webhook">
              </mat-form-field>
            </div>
          </div>
      </t4-container>
    </mat-dialog-content>

    <mat-dialog-actions>
        <button class="mat-raised-button mat-primary" (click)="save()">{{ 'turbo.core.createScheduledReportDialog.cmdSave' | translate : 'Save'}}</button>
        <button class="mat-raised-button" (click)="close()">{{ 'turbo.core.createScheduledReportDialog.cmdCancel' | translate : 'Cancel'}}</button>
    </mat-dialog-actions>
    <div class="loader" *ngIf="loading.dialog">
        <div class="message">{{ loadingMessageKey | translate : loadingMessageDefault }}</div>
        <mat-progress-bar mode="indeterminate" style="width: 100%; bottom: 0;" *ngIf="loading.dialog"></mat-progress-bar>
    </div>
